export default __webpack_public_path__ + "static/media/dropdown-icon.61be576e.svg";